module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/adress-book-2-9d29fc1207f0e25a9321d9920a310382.svg";